<div class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-6 truncate">
            Well Integrity Activity Planning
        </div>
        <div role="tablist" class="tabs tabs-lifted w-fit">
            <a *ngFor="let tab of tabs" role="tab" [ngClass]="{
                        'tab text-sm': true, 
                        'custom-active-tab': router.url.includes(tab.route),
                        'custom-inactive-tab': !router.url.includes(tab.route), 
                    }" (click)="onSelectedTab(tab.route)">{{tab.name}}</a>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>